import { Node } from "../../src/shell/Actions/Action";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { empty } from "../characters/empty";
import { jenny } from "../characters/Jenny";
import { joe } from "../characters/Joe";
import { mc } from "../characters/MC";
import { mila } from "../characters/Mila";
import { strangerFemale } from "../characters/StrangerFemale";
import { doTransition, doWaitImageByTime } from "../helpers/helpers";
import { images } from "./images";
import { V8JennyDateAfter } from "./V8";
import SoundClass from "../../src/shell/Sound";
import { music } from "./sounds";

const v8 = images.v8;
export const V8JennyDate = async (): Promise<any> => {
    if (mc.properties.joeStatus === "enemy") {

    } else {

        mc.think(`So I have a car... Now I gotta see if Jenny is even available.`);
    }
    ImageClass.setImage(images.v8.V8RoomNightOnPhone);
    empty.think(`*Dialing...*`);
    jenny.talk(`Hey ${mc.name}!`, { method: "Over Phone" });
    mc.talk(`Hey Jenny! How are you?`, { method: "On Phone" });
    jenny.talk(`I'm great! I was hoping you'd call!`, { method: "Over Phone" });
    mc.talk(`So I'm glad I did!\nAre you busy?`, { method: "On Phone" });
    jenny.talk(`Not at all!`, { method: "Over Phone" });
    mc.talk(`Wanna go out?`, { method: "On Phone" });
    jenny.talk(`I'd love to!`, { method: "Over Phone" });
    jenny.talk(`Actually, there is a bar I wanted to check if you don't mind.`, { method: "Over Phone" });
    mc.talk(`Not at all, sounds great, I'll pick you up.`, { method: "On Phone" });
    jenny.talk(`Great! I'll go and get ready.`, { method: "Over Phone" });

    doWaitImageByTime(v8.V8RoomNight);
    mc.think(`Now I just need to wait for Joey to bring his car and I'm ready to go.`);

    empty.think(`*Phone Rings*`);
    mc.think(`Nice! That was quick.`);
    ImageClass.setImage(images.v8.V8RoomNightOnPhone);
    joe.talk(`Yo! I'm outside.`, { method: "Over Phone" });
    mc.talk(`Coming.`, { method: "On Phone" });
    doWaitImageByTime(images.v7.JoeBringsCar_0);
    mc.think(`There he is.`);
    doWaitImageByTime(images.v7.JoeBringsCar_1);
    mc.talk(`Thanks man! I didn't want to pick her up with Emily's car.`, { method: "On Phone" });
    doWaitImageByTime(images.v7.JoeBringsCar_3);
    if (Question.globalAnswers.v8JoeMorningAgreeThreesomeWithVanessa || Question.globalAnswers.v8JoeMorningAgreeThreesomeWithVanessaPhone) {
        joe.talk(`Sure thing bro!\nBetter get in there quick so you'll get back in time for our little party!`, { method: "Over Phone" });
    } else {

        joe.talk(`Sure thing bro!\nBetter get in there quick so you won't be late!`, { method: "Over Phone" });
    }
    mc.talk(`Thank you man!`, { method: "On Phone" });
    doWaitImageByTime(images.v7.JoeBringsCar_4);
    mc.think(`Off to Jenny's...`);

    doTransition(v8.V8JennyDate_2_2);
    empty.think(`*Honk Honk*`);
    doWaitImageByTime(v8.V8JennyDate_2);
    mc.think(`There she is.`);
    doWaitImageByTime(v8.V8JennyDate_3);
    mc.think(`Oh wow, nice dress!`);
    doWaitImageByTime(v8.V8JennyDate_4);
    mc.think(`She always dresses so elegant.`);
    doWaitImageByTime(v8.V8JennyDate_5, { wait: true });
    doWaitImageByTime(v8.V8JennyDate_6);
    jenny.talk(`Hey ${mc.name}!`);

    await jenny.setQuestion(new Question({ text: `I was just making sure it's you.`, options: { think: false }, key: `v8JennyDateCheckedHerOut` })
        .option({ title: `Check her out`, key: true })
        .option({ title: `Don't check`, key: false }));


    if (Question.globalAnswers.v8JennyDateCheckedHerOut) {
        doWaitImageByTime(v8.V8JennyDate_7);
        mc.talk(`Just making sure it's you!`);
        doWaitImageByTime(v8.V8JennyDate_8);
        jenny.talk(`Haha! I see what you are doing there.`);
        mc.talk(`Can you blame me?`);
        jenny.talk(`Haha.`);

    }

    doWaitImageByTime(v8.V8JennyDate_1);
    mc.talk(`So, where are we going?`);
    // TODO: V8JennyDate_1 partial for talking
    jenny.talk(`There is a country bar that is really cool if you are up for it.`);
    mc.talk(`Sure, that sounds like fun.`);
    // TODO: V8JennyDate_1 partials talking happy
    jenny.talk(`Great! Just drive and I'll show you how to get there.`);
    mc.talk(`So... How was your day?`);

    ImageClass.setImage(images.v8.V8JennyDate_14);
    jenny.talk(`You won't even believe it!`);
    await mc.setQuestion(new Question({ text: `Here it comes`, options: { think: true }, key: `v8JennyDateListenedToJenny` })
        .option({ title: `Listen to her`, key: true })
        .option({ title: `Drift away`, key: false }));


    if (Question.globalAnswers.v8JennyDateListenedToJenny) {
        await mc.set((properties) => {
            properties.jennyRelationship++;
        });

        mc.think(`Here it comes.`);
        ImageClass.setImage(images.v8.V8JennyDate_11);
        jenny.talk(`Well, I don't even know where to begin!`);
        jenny.talk(`So my morning started when I woke up early. Actually, it was earlier than I usually wake up because my alarm didn't go off...`);
        ImageClass.setImage(images.v8.V8JennyDate_13);
        jenny.talk(`So I woke up in a panic, thinking I was already late for work. But then I realized it was just 6 am and I had set my alarm for the wrong time.`);
        jenny.talk(`So I had a little extra time to get ready, which was a relief. But then, when I went to take a shower, I realized there was no hot water.`);
        ImageClass.setImage(images.v8.V8JennyDate_14);
        jenny.talk(`Can you believe it?`);
        jenny.talk(`I mean, I know I woke up earlier than usual, but it's not like I was the first one in the shower.`);

        ImageClass.setImage(images.v8.V8JennyDate_15);
        jenny.talk(`And I was really looking forward to a nice warm shower to start my day off right.`);
        jenny.talk(`But nope! Cold water it was.`);
        ImageClass.setImage(images.v8.V8JennyDate_12);
        jenny.talk(`And then, when I went to get dressed, I realized I had forgotten to do my laundry and all my clothes were dirty.`);

        jenny.talk(`So I had to wear a wrinkled outfit to work, which is not exactly the best first impression to make on a new client.`);
        ImageClass.setImage(images.v8.V8JennyDate_14);
        jenny.talk(`And then, when I was getting ready to leave the house, I couldn't find my keys anywhere.`);

        ImageClass.setImage(images.v8.V8JennyDate_15);
        jenny.talk(`I looked everywhere, but they were nowhere to be found...`);
        jenny.talk(`I was starting to get really frustrated and worried, because I had to be at work in like twenty minutes and I had no idea how I was going to get there without my keys.`);

        ImageClass.setImage(images.v8.V8JennyDate_11);
        jenny.talk(`I was looking in all the usual places, like my purse and the kitchen counter, but they were nowhere to be found.`);
        jenny.talk(`But just when I was about to give up and call a cab, I remembered I had put them in my coat pocket the day before because I was afraid of losing them.`);
        ImageClass.setImage(images.v8.V8JennyDate_14);
        jenny.talk(`Talk about a close call! Right?`);

        ImageClass.setImage(images.v8.V8JennyDate_13);
        jenny.talk(`But that's not the worst part!`);
        ImageClass.setImage(images.v8.V8JennyDate_11);
        jenny.talk(`The worst part was when I finally made it to my desk at work and saw Janis.`);

        ImageClass.setImage(images.v8.V8JennyDate_14);
        jenny.talk(`You don't know Janis, do you?`);
        ImageClass.setImage(images.v8.V8JennyDate_15);
        jenny.talk(`She's this 70-year-old lady who works in our office. And she loves to talk, especially in the mornings, before I've even had my coffee.`);

        jenny.talk(`She came up to me and said, "Hey Jenny, wanna hear what my grandson did yesterday?" And I'm like, "Sure...".`);
        jenny.talk(`You know because I'm a nice girl, but seriously, Janis, let me wake up first. I hope I don't sound rude, but I'm not really a morning person, you know.`);

        ImageClass.setImage(images.v8.V8JennyDate_14);
        jenny.talk(`Well, maybe that's not true, I don't mind mornings, but I definitely need my coffee.`);



    }

    doTransition(images.v8.V8JennyDate_11);
    jenny.talk(`Wow, we are already here.`);

    return jump(V8JennyDate_Bar, "V8JennyDate_Bar");
};
export const V8JennyDate_Bar = async (): Promise<any> => {
    doTransition(v8.V8JennyDateBar_2);
    // SoundClass.startMusic(music.V8JennyDate_Bar, { shouldPlay: true, loop: true });
    jenny.talk(`Wow look at this place! It's better than I thought!`);
    ImageClass.setImage(images.v8.V8JennyDateBar_4);
    jenny.talk(`They even have a band playing and everything!`);
    ImageClass.setImage(images.v8.V8JennyDateBar_3);
    mc.talk(`Yes, this place is awesome!`);
    jenny.talk(`I'm glad we found some seats!`);
    // FIXME: bra
    doWaitImageByTime(v8.V8JennyDateBar_5);
    mila.talk(`Hey! My name is ${mila.name} and I'll be your waitress for tonight.`);
    ImageClass.setImage(images.v8.V8JennyDateBar_8);
    jenny.talk(`I like your hat!`);
    mila.talk(`Thank you!`);
    ImageClass.setImage(images.v8.V8JennyDateBar_10);
    await mila.setQuestion(new Question({ text: `Are you ready to order?`, options: { think: false }, key: `v8JennyDateCheckedWaitressOut` })
        .option({ title: `Check her out`, key: true })
        .option({ title: `Don't check her out`, key: false }));

    if (Question.globalAnswers.v8JennyDateCheckedWaitressOut) {
        mc.think(`Damn...`);
        doWaitImageByTime(v8.V8JennyDateBar_6);
        mc.think(`Hello there ${mila.name}...`);
        mc.think(`How come waitresses are always so hot?`);
        doWaitImageByTime(v8.V8JennyDateBar_7);
        mc.think(`I just hope Jenny didn't notice.`);

    } else {

    }
    ImageClass.setImage(images.v8.V8JennyDateBar_8);
    jenny.talk(`I would like a glass of whiskey.`);
    ImageClass.setImage(images.v8.V8JennyDateBar_9);
    mila.talk(`No problem!`);
    ImageClass.setImage(images.v8.V8JennyDateBar_10);
    mc.talk(`And for you?`);
    mc.talk(`Same.`);
    ImageClass.setImage(images.v8.V8JennyDateBar_11);
    mila.talk(`Got it.`);
    ImageClass.setImage(images.v8.V8JennyDateBar_10);
    mila.talk(`Anything else?`);
    ImageClass.setImage(images.v8.V8JennyDateBar_9);
    jenny.talk(`Not for now, thank you.`);
    mila.talk(`Great! I'll be right back with your drinks!`);

    // 
    doWaitImageByTime(v8.V8JennyDateBar_13);
    mc.talk(`I didn't know you are into hats.`);
    ImageClass.setImage(v8.V8JennyDateBar_14);
    jenny.talk(`Haha! Well, I am.`);
    ImageClass.setImage(v8.V8JennyDateBar_15);
    jenny.talk(`I mean, there is something I haven't told you.`);
    ImageClass.setImage(v8.V8JennyDateBar_16);
    jenny.talk(`Remember when I told you I grew up with a three brothers?`);
    ImageClass.setImage(v8.V8JennyDateBar_13);
    mc.talk(`I do.`);
    ImageClass.setImage(v8.V8JennyDateBar_14);
    jenny.talk(`I didn't tell you were we lived!`);
    ImageClass.setImage(v8.V8JennyDateBar_16);
    jenny.talk(`I actually grew up on a farm.`);
    ImageClass.setImage(v8.V8JennyDateBar_14);
    jenny.talk(`As a country girl I feel at home here.`);
    ImageClass.setImage(v8.V8JennyDateBar_13);
    mc.talk(`You? A country girl? I would have never guessed! You always dress so elegantly`);
    ImageClass.setImage(v8.V8JennyDateBar_14);
    jenny.talk(`Haha, yeah. I like to dress up when I go out. It's a way of escaping the farm life, I guess.`);
    ImageClass.setImage(v8.V8JennyDateBar_13);
    mc.talk(`What was it like growing up on a farm?`);
    ImageClass.setImage(v8.V8JennyDateBar_14);
    jenny.talk(`It was the best. We had so much space to run and play, and the fresh air was amazing.`);
    ImageClass.setImage(v8.V8JennyDateBar_17);
    jenny.talk(`My brothers and I used to play all sorts of games in the fields. We'd have races, catch frogs in the pond, and climb trees.`);
    jenny.talk(`My dad taught us all about farming, too. I remember one time when we were planting corn, and he let me drive the tractor. I felt like a real farmer!`);
    ImageClass.setImage(v8.V8JennyDateBar_18);
    jenny.talk(`And the best part was the animals. We had chickens, pigs, and horses. We used to ride the horses all around the farm.`);
    jenny.talk(`I don't think I'll ever forget those days. I love city life, but there's something special about being surrounded by nature and animals.`);
    ImageClass.setImage(v8.V8JennyDateBar_14);
    jenny.talk(`I'm grateful for growing up on the farm. It taught me a lot about hard work and being resourceful. Plus, I still love a good pair of boots and a cowboy hat!`);

    doWaitImageByTime(v8.V8JennyDateBar_19);
    mila.talk(`Hey guys! Here are your drinks!`);
    doWaitImageByTime(v8.V8JennyDateBar_20);
    mila.talk(`Here is yours...`);
    doWaitImageByTime(v8.V8JennyDateBar_21);
    mila.talk(`And yours...`);
    mc.talk(`Thank you!`);
    doWaitImageByTime(v8.V8JennyDateBar_22);
    mila.talk(`Anything else?`);
    mc.talk(`Yes.`);
    mc.talk(`Can Jenny borrow your hat for a quick second?`);
    doWaitImageByTime(v8.V8JennyDateBar_23);
    mila.talk(`Of course!`);
    jenny.talk(`Haha.`);
    doWaitImageByTime(v8.V8JennyDateBar_24);
    jenny.talk(`So? How do I look?`);
    mc.talk(`Mmm... I'm still not sure I believe it.`);
    ImageClass.setImage(v8.V8JennyDateBar_25);
    jenny.talk(`Thank you.`);
    mila.talk(`You're welcome! Just call me if you need anything else.`);

    // left
    doWaitImageByTime(v8.V8JennyDateBar_26);
    jenny.talk(`No way you don't believe me!`);
    mc.talk(`There is one way you can prove it to me...`);
    jenny.talk(`How?`);
    mc.talk(`How good were you with milking cows?`);
    ImageClass.setImage(v8.V8JennyDateBar_27);
    jenny.talk(`You are so naughty! I had a feeling you'd say that!`);

    ImageClass.setImage(v8.V8JennyDateBar_13);
    mc.talk(`Can you blame me?`);
    ImageClass.setImage(v8.V8JennyDateBar_16);
    jenny.talk(`Honestly. No.`);
    ImageClass.setImage(v8.V8JennyDateBar_17);
    jenny.talk(`There are a lot of stigmas about country folks.`);
    jenny.talk(`But I learned to ignore them.`);
    ImageClass.setImage(v8.V8JennyDateBar_16);
    jenny.talk(`My father, who is also my uncle, always told me not to listen to what people say.`);
    mc.talk(`...`);
    jenny.talk(`It's a joke, ok.`);
    ImageClass.setImage(v8.V8JennyDateBar_15);
    jenny.talk(`My parents are only second-blood related.`);
    mc.talk(`Another joke?`);
    ImageClass.setImage(v8.V8JennyDateBar_17);
    jenny.talk(`Of course!`);
    ImageClass.setImage(v8.V8JennyDateBar_14);
    jenny.talk(`They just met at Starbucks.`);
    ImageClass.setImage(v8.V8JennyDateBar_13);
    mc.talk(`Starbucks? Seriously?`);
    ImageClass.setImage(v8.V8JennyDateBar_14);
    jenny.talk(`Yes! They were both grabbing coffee before work one day. My dad was getting ready to head to the farm, and my mom was on her way to the office.`);
    jenny.talk(`They struck up a conversation, and the rest is history. They hit it off and started dating.`);
    ImageClass.setImage(v8.V8JennyDateBar_17);
    jenny.talk(`Even though my dad was a farmer and my mom was a city girl, they made it work.`);
    ImageClass.setImage(v8.V8JennyDateBar_13);
    mc.talk(`So you are following in your mother's footsteps.`);
    ImageClass.setImage(v8.V8JennyDateBar_16);
    jenny.talk(`Mmm... I don't know.`);
    jenny.talk(`Even though I love the farm life, I also love the city...`);
    jenny.talk(`I would go back in a heartbeat, it's not like I left because I didn't like it.`);
    ImageClass.setImage(v8.V8JennyDateBar_13);
    mc.talk(`That makes sense, just do what feels right for you.`);
    ImageClass.setImage(v8.V8JennyDateBar_17);
    jenny.talk(`Exactly!`);

    doTransition(v8.V8JennyDateBar_29);
    jenny.talk(`Oh wow, the time flew by, almost everyone has left.`);
    ImageClass.setImage(v8.V8JennyDateBar_28);
    mc.talk(`Yeah, maybe it's time for us to get going as well.`);
    jenny.talk(`I agree!`);

    // SoundClass.stopMusic(music.V8JennyDate_Bar);
    return jump(V8JennyDate_ReturningHome, "V8JennyDate_ReturningHome");
};

export const V8JennyDate_ReturningHome = async (): Promise<any> => {
    doTransition(images.v8.V8JennyDate_45);
    mc.talk(`Here we are.`);
    jenny.talk(`Thank you!`);
    mc.talk(`Sec, let me give you a proper goodbye.`);
    doWaitImageByTime(v8.V8JennyDate_31);
    jenny.talk(`I had a really wonderful time!`);
    doWaitImageByTime(v8.V8JennyDate_32);
    await mc.setQuestion(new Question({ text: `Me too`, options: { think: false }, key: `v8JennyDateKissedHer` })
        .option({ title: `Kiss her`, key: true })
        .option({ title: `Don't kiss`, key: false }));


    if (Question.globalAnswers.v8JennyDateKissedHer) {
        doWaitImageByTime(v8.V8JennyDate_34);
        await jenny.setQuestion(new Question({ text: `Mmm...`, options: { think: false }, key: `v8JennyDateTouchedBreasts` })
            .option({ title: `Touch her breast`, key: true })
            .option({ title: `Don't touch`, key: false }));


        if (Question.globalAnswers.v8JennyDateTouchedBreasts) {
            await mc.set((properties) => {
                properties.jennyRelationship += 3;
            });
            doWaitImageByTime(v8.V8JennyDate_36);
            mc.think(`It's so soft!`);
            doWaitImageByTime(v8.V8JennyDate_37);
            mc.think(`A bit further...`);
            doWaitImageByTime(v8.V8JennyDate_38);
            mc.think(`Almost there...`);
            doWaitImageByTime(v8.V8JennyDate_39);
            mc.think(`FUCK!`);
            ImageClass.setImage(images.v8.V8JennyDate_40);
            jenny.talk(`Good night ${mc.name}.`);


        } else {
            // TODO: like V8JennyDate_32 but smiling without touching breast
            jenny.talk(`Good night ${mc.name}.`);

        }


    } else {
        await mc.set((properties) => {
            properties.jennyRelationship--;
        });
        // TODO: V8JennyDate_32 same this but natural
        jenny.talk(`Good night ${mc.name}.`);

    }

    doWaitImageByTime(v8.V8JennyDate_41);
    mc.think(`There she goes...`);
    if (mc.properties.jennyRelationship > 7) {
        doWaitImageByTime(v8.V8JennyDate_42);
        mc.think(`And the turn around!`);
    } else {

    }
    if (Question.globalAnswers.v8JoeMorningAgreeThreesomeWithVanessa || Question.globalAnswers.v8JoeMorningAgreeThreesomeWithVanessaPhone) {

    } else {
        mc.think(`Time to get back home.`);
        doTransition(images.v8.V8RoomNight);

    }
    if (Question.globalAnswers.v8JennyDateTouchedBreasts) {
        mc.think(`I wonder how long she can keep blue balling me.`);
        mc.think(`Surely next date she's gonna give out something!`);
        mc.think(`At least I got to touch those godly boobs.`);
    } else {
        mc.think(`Things are moving great between us.`);
    }

    return jump(V8JennyDateAfter, "V8JennyDateAfter");
};
